<template>
    <div>
        <!-- Proposal Generator Product/Services Type Modal -->
        <pg-product-services-type-modal ref="PGProductServicesTypeModal"></pg-product-services-type-modal>
        <!-- Proposal Generator Product/Services Type Modal End -->

        <!-- Proposal Generator Product/Services Add/Edit Modal -->
        <pg-product-services-modal ref="PGProductServicesModal"
                                   :typesData="typesData"
                                   :categoriesData="categoriesData"
                                   :salesTaxData="salesTaxData"
                                   :productServicesCustomFieldData="productServicesCustomFieldData"
                                   :editProductServicesData="editProductServicesData"
                                   :editProductServicesType="editProductServicesType" />
        <!-- Proposal Generator Product/Services Add/Edit Modal End -->

        <!-- Proposal Generator Bundle Add/Edit Modal -->
        <pg-bundle-modal ref="PGBundleModal"
                         :allPGProductServices="allPGProductServices"
                         :editProductServicesData="editProductServicesData"
                         :editProductServicesType="editProductServicesType" />
        <!-- Proposal Generator Bundle Add/Edit Modal End -->

        <div class="row">
            <div class="col-6">
                <div class="icon-inner-input right-side-icon">
                    <i v-if="filter.dataLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                    <input class="form-control float-left mb-2" placeholder="Search product & services" @input="debounceFilter"/>
                </div>
            </div>
            <div class="col-6">
                <button class="btn btn-primary float-right mb-2" @click="openPGProductServicesTypeModal">Add New</button>
            </div>
        </div>

        <!-- Proposal Generator Product/Services Table -->
        <table class="table table-bordered table-responsive pg-sales-tax-table">
            <thead>
            <tr>
                <th style="width: 30%; font-size: 15px; font-weight: 400;">Product</th>
                <th style="width: 15%; font-size: 15px; font-weight: 400;">Type</th>
                <th style="width: 15%; font-size: 15px; font-weight: 400;">Description</th>
                <th style="width: 15%; font-size: 15px; font-weight: 400;">Price</th>
                <th style="width: 15%; font-size: 15px; font-weight: 400;">Taxable</th>
                <th style="width: 10%; font-size: 15px; font-weight: 400;">Actions</th>
            </tr>
            </thead>
            <tbody v-if="!showLoaderForPG && allPGCategories.length > 0">
                <pg-product-and-services-nested-listing v-for="item in allPGCategories" :key="item.id" :item="item" :level="0" />
            </tbody>
            <tbody v-else-if="!showLoaderForPG && allPGCategories.length == 0">
                <tr>
                    <td colspan="11" class="text-center"> No Product Or Service Added Yet</td>
                </tr>
            </tbody>
            <tbody v-else-if="showLoaderForPG">
                <tr>
                    <td colspan="11" class="text-center"> Loading Product And Services <i class="fa fa-spin fa-spinner text-teal" aria-hidden="true"></i></td>
                </tr>
            </tbody>
        </table>
        <!-- Proposal Generator Product/Services Table End -->

        <!-- Remove Product/Services Confirmation Modal -->
        <div class="modal" id="pg-remove-product-services-modal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete item?</h5>
                        <button type="button" class="close" @click="closePGRemoveProductServicesModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Are you sure you want to delete this item: {{ removeProductServicesObj.label }}</p>
                    </div>
                    <div class="modal-footer">
                        <button class="no-btn-properties mx-4" @click="closePGRemoveProductServicesModal()">Cancel</button>
                        <button type="button" class="btn btn-danger" @click="removeProductServices">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Remove Product/Services Confirmation Modal End -->

    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Form from "../../../../utils/form";
import NestedListing from "../../../shared/nested-listing.vue";
import PgProductAndServicesProductSpecs from "./pg-product-and-services-product-specs.vue";
import PgProductAndServicesBundleTable from "./pg-product-and-services-bundle-table.vue";
import PgProductServicesTypeModal from "./modal/pg-product-services-type-modal.vue";
import PgProductServicesModal from "./modal/pg-product-services-modal.vue";
import PgBundleModal from "./modal/pg-bundle-modal.vue";
import PgProductAndServicesNestedListing from "./pg-product-and-services-nested-listing.vue";

export default {
    name: "pg-product-and-services-settings",
    props:[],
    components: {
        PgProductAndServicesNestedListing,
        PgBundleModal,
        PgProductServicesModal,
        PgProductServicesTypeModal,
        PgProductAndServicesBundleTable,
        PgProductAndServicesProductSpecs, Multiselect, Treeselect, NestedListing,
    },
    data() {
        return {
            typesData: [],
            salesTaxData: [],
            categoriesData: [],
            productServicesCustomFieldData: [],
            allPGProductServices: [],
            allPGCategories: [],
            removeProductServicesObj: {
                data: {},
                label: '',
                type: '',
            },
            filter: {
                searchTimeout: null,
                dataLoading: false,
            },
            editProductServicesData: null,
            editProductServicesType: '',
            allPGCategoriesData: [],
            showLoaderForPG: false,
        }
    },
    mounted() {
        let self = this;
        self.getAllPGCategoriesCompleteData();
        self.getAllPGProductServices();
        self.getFieldData();

        Bus.$on('open-pg-product-services-modal', function() {
            self.$refs.PGProductServicesModal.open();
        });
        Bus.$on('open-pg-bundle-modal', function() {
            self.$refs.PGBundleModal.open();
        });
        Bus.$on('get-all-pg-product-services', function() {
            self.getAllPGCategoriesCompleteData();
            self.getAllPGProductServices();
        });
        Bus.$on('edit-product-services', function(data, label, type) {
            self.editProductServicesData = data;
            self.editProductServicesType = type;
            if(label === 'bundle') {
                self.$refs.PGBundleModal.open();
            }
            else {
                self.$refs.PGProductServicesModal.$refs.ProductSpecs.addMoreSpecsButton = true;
                self.$refs.PGProductServicesModal.open();
            }
        });
        Bus.$on('product-services-modal-closed', function() {
            self.editProductServicesData = null;
            self.$refs.PGProductServicesModal.$refs.ProductSpecs.addMoreSpecsButton = false;
            self.$refs.PGProductServicesModal.pgIsProductSpecs = false;
        });
        Bus.$on('product-services-bundle-modal-closed', function() {
            self.editProductServicesData = null;
        });
        Bus.$on('open-remove-product-services-modal', function(data, type) {
            self.openPGRemoveProductServicesModal();
            self.removeProductServicesObj.data = data;
            self.removeProductServicesObj.type = type;
            self.removeProductServicesObj.label = (type === 'bundle' ? data.bundle_name : data.product_service_name);
        });
    },
    methods: {
        openPGProductServicesTypeModal() {
            this.$refs.PGProductServicesTypeModal.open();
        },
        openPGRemoveProductServicesModal() {
            $('#pg-remove-product-services-modal').modal('show');
        },
        closePGRemoveProductServicesModal() {
            $('#pg-remove-product-services-modal').modal('hide');
            this.removeProductServicesObj.data = {};
            this.removeProductServicesObj.label = '';
            this.removeProductServicesObj.type = '';
        },
        debounceFilter(event) {
            let self = this;
            self.allPGCategories = self.allPGCategoriesData;
            clearTimeout(self.filter.searchTimeout);
            self.filter.searchTimeout = setTimeout(() => {
                if(event.target.value !== null && event.target.value !== undefined && event.target.value !== "") {
                    this.allPGCategories = this.filterNodes(this.allPGCategories, self.filterByName, event.target.value);
                }
                else {
                    self.getAllPGCategoriesCompleteData(event.target.value);
                }
            }, 700, self);
        },
        getFieldData() {
            let self = this;
            axios.get(route('api.proposal-settings.product-services.get-field-data')).then((response) => {
                 self.typesData = response.data.types;
                 self.salesTaxData = response.data.salesTax;
                 self.categoriesData = response.data.categories;
                 self.productServicesCustomFieldData = response.data.productServicesCustomField;
            });
        },
        getAllPGProductServices(filter = null) {
            let self = this;
            self.filter.dataLoading = true;
            axios.get(route('api.proposal-settings.product-services.index'), {filter}).then(response => {
                this.allPGProductServices = response.data.data;
                self.filter.dataLoading = false;
            });
        },
        getAllPGCategoriesCompleteData(filter = null) {
            let self = this;
            self.showLoaderForPG = true;
            self.filter.dataLoading = true;
            axios.get(route('api.proposal-settings.category.get-categories-complete-data', {filter})).then(response => {
                this.allPGCategories = response.data.data;
                this.allPGCategoriesData = response.data.data;
                self.filter.dataLoading = false;
                self.showLoaderForPG = false;
            });
        },
        removeProductServices() {
            let self = this;
            axios.post(route('api.proposal-settings.product-services.delete-product-services'), {removeProductServicesData: self.removeProductServicesObj.data}).then(response => {
                self.closePGRemoveProductServicesModal();
                self.getAllPGCategoriesCompleteData();
            });
        },
        filterNodes(data, filterFunc, queryParam) {
            let self = this;
            return _.filter(data, node => {
                const newNode = _.cloneDeep(node);
                if (newNode.children && newNode.children.length > 0) {
                    newNode.children = self.filterNodes(newNode.children, filterFunc, queryParam);
                }
                return filterFunc(newNode, queryParam) || (newNode.children && newNode.children.length > 0);
            });
        },
        filterByName(node, query) {
            return node.name?.toLowerCase().includes(query?.toLowerCase());
        }
    }
};
</script>

<style scoped>
.pg-sales-tax-table tbody tr td {
    font-size: 13px;
    font-weight: normal;
}
.icon-inner-input {
    position: relative;
}
.icon-inner-input .fa-spin {
    position: absolute;
    padding: 10px;
    pointer-events: none;
}
.right-side-icon .fa-spin {
    right: 0px;
}
.right-side-icon input {
    padding-right: 30px;
}
.bundle-table th,
.bundle-table td {
    padding: 15px;
}
</style>
